import { forwardRef, MouseEvent } from "react";
import { Store, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { STORE_FILTER_TEXT } from "./constants";

interface StoreFilterTriggerProps {
  appliedCount: number;
  onClearApplied: (event: MouseEvent) => void;
}

/**
 * Botão de abertura do filtro. Encaminha ref/props para o `PopoverTrigger asChild`.
 * Mostra um badge com a contagem aplicada e um X para limpar sem abrir o painel.
 */
export const StoreFilterTrigger = forwardRef<
  HTMLButtonElement,
  StoreFilterTriggerProps
>(({ appliedCount, onClearApplied, ...props }, ref) => (
  <Button
    ref={ref}
    variant="outline"
    size="sm"
    className="h-8 border-dashed"
    {...props}
  >
    <Store className="mr-2 h-4 w-4" />
    {STORE_FILTER_TEXT.triggerLabel}
    {appliedCount > 0 && (
      <>
        <div className="mx-2 h-4 w-[1px] bg-gray-300" />
        <Badge variant="secondary" className="rounded-sm px-1 font-normal">
          {appliedCount} {STORE_FILTER_TEXT.storesUnit}
        </Badge>
        <X
          className="ml-1 h-3 w-3 cursor-pointer hover:text-destructive"
          onClick={onClearApplied}
        />
      </>
    )}
  </Button>
));

StoreFilterTrigger.displayName = "StoreFilterTrigger";
